module.exports = __webpack_public_path__ + "img/content6.6dad2f2c.png";